module.exports = __webpack_public_path__ + "media/images/pages/careers-week/daisy-8a49ba930ec26b1d942add4a4c5bb91a.jpg";